import { render } from "./clients.vue?vue&type=template&id=5d15238c&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"

import "./clients.vue?vue&type=style&index=0&id=5d15238c&scoped=true&lang=scss"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d15238c"]])

export default __exports__